import { getLangName } from './pick-lang-name';
import { getRealValue, getDataItemText } from './pick-dataitem-value';
import { replaceValueData, getMmFromPx, getPxFromMm } from './print-template';
export default {
    getLangName,
    getRealValue,
    getDataItemText,
    replaceValueData,
    getMmFromPx,
    getPxFromMm,
};
